export default __webpack_public_path__ + "static/media/socialimpact3.b19ed631.jpeg";